/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();

(function () {

    let startX = 0;
    let startY = 0;
    let moved = false;
    const threshold = 10;

    function onTouchStart(e) {
        const tag = e.target.closest('.gh-card-tags .gh-article-tags');
        if (!tag) return;

        const touch = e.touches[0];
        startX = touch.clientX;
        startY = touch.clientY;
        moved = false;

        tag._touched = true; // このタグが対象
    }

    function onTouchMove(e) {
        if (!e.touches || e.touches.length === 0) return;

        const touch = e.touches[0];
        const dx = Math.abs(touch.clientX - startX);
        const dy = Math.abs(touch.clientY - startY);

        if (dx > threshold || dy > threshold) {
            moved = true;
        }
    }

    function onTouchEnd(e) {
        const tag = e.target.closest('.gh-card-tags .gh-article-tags');
        if (!tag || !tag._touched) return;

        tag._touched = false;

        // スクロールしてたら何もしない
        if (moved) return;

        const card = tag.closest('.gh-card-link');
        if (card) card.classList.remove('is-active');

        tag.classList.add('is-active');

        const url = tag.dataset.url;

        setTimeout(() => {
            tag.classList.remove('is-active');
            if (url) {
                window.location.href = url;
            }
        }, 150);

        e.preventDefault();
        e.stopPropagation();
    }

    function onClick(e) {
        // PC用
        const tag = e.target.closest('.gh-card-tags .gh-article-tags');
        if (!tag) return;

        const card = tag.closest('.gh-card-link');
        if (card) card.classList.remove('is-active');

        tag.classList.add('is-active');

        const url = tag.dataset.url;

        setTimeout(() => {
            tag.classList.remove('is-active');
            if (url) {
                window.location.href = url;
            }
        }, 150);

        e.preventDefault();
        e.stopPropagation();
    }

    document.addEventListener('touchstart', onTouchStart, { passive: true });
    document.addEventListener('touchmove', onTouchMove, { passive: true });
    document.addEventListener('touchend', onTouchEnd);
    document.addEventListener('click', onClick);

})();